import { Grid, Typography } from "@mui/material";
import { PendingPericiasDisplayFieldsToggler } from "../../list-pending-pericias/ui/pending-pericias-display-fields-toggler.component";
import { PendingPericiasList } from "../../list-pending-pericias/ui/pending-pericias-list.component";
import { PericiaInvoiceItem } from "../../../../entities/pericia";
import { currencyMask, formatIntegerToCurrency } from "../../../../shared/lib/numbers";
import { capitalizeFirstLetter } from "../../../../shared/helpers/string";
import { PendingPericiasPDFDownload } from "../../create-pending-pericias-pdf/ui/pending-pericias-pdf-download.component";

interface ListPericiasByCostumerListProps {
  props: {
    pericias: PericiaInvoiceItem[];
    selectedFieldsToDisplay: {
      displayPlate: boolean;
      displayChassis: boolean;
      displayDate: boolean;
      displayPrice: boolean;
      displayUserName: boolean;
      displayTotalHours: boolean;
    };
    totalPrice: number;
    totalCustomPrice: number;
    start: Date;
    end: Date;
    handleSelectedFieldsToDisplayChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    costumer: any; // For the PDF costumer prop
  };
}

export const ListPericiasByCostumerList: React.FC<ListPericiasByCostumerListProps> = ({ props }) => {
  const { pericias, selectedFieldsToDisplay, totalPrice, totalCustomPrice, start, end, handleSelectedFieldsToDisplayChange, costumer } =
    props;

  const formattedTotalPrice = currencyMask(formatIntegerToCurrency(totalPrice));
  const totalPericias = pericias.length;

  if (totalPericias === 0) return <></>;

  return (
    <>
      <Grid item xs={12} sm={12} mt={5} mb={3} sx={{ textAlign: "left" }}>
        <Typography variant="h5" component="div">
          {`${capitalizeFirstLetter(pericias[0].costumer.name)} - ${start.toLocaleDateString("pt-BR")} à ${end.toLocaleDateString(
            "pt-BR"
          )}`}
        </Typography>
        <Typography variant="body1" component="div">
          {`Foram encontradas ${totalPericias} pericias totalizando ${formattedTotalPrice}`}
        </Typography>
      </Grid>
      <PendingPericiasDisplayFieldsToggler
        props={{
          selectedFieldsToDisplay,
          toggleDisplay: handleSelectedFieldsToDisplayChange
        }}
      />
      <Typography variant="subtitle1" component="p">
        Utilize o celular com a tela deitada para visualizar a lista*
      </Typography>
      <PendingPericiasList
        props={{
          pericias,
          selectedFieldsToDisplay,
          totalPrice: totalCustomPrice
        }}
      />
      <PendingPericiasPDFDownload
        props={{
          pericias,
          periciaCount: totalPericias, // Pass total count explicitly for PDF
          costumer,
          start,
          end,
          totalPrice: totalCustomPrice,
          displayFields: selectedFieldsToDisplay
        }}
      />
    </>
  );
};
